// import { useEffect, useState } from "react";
// import EventCategoryTable from "./EventCategoryTable";
// import EventCategoryForm from "./EventCategoryForm";
// import Modal from "components/common/Modal";
// import Alert from "components/common/Alert";
// import { useEventCategory } from "./hooks/useEventCategory";
// import { useOrganizers } from "components/company/hooks/useOrganizers";
// import EventCategoryModal from "./EventCategoryModal";

// export default function EventCategoryContainer() {
//   const {
//     data,
//     loading,
//     loadCategories,
//     addCategory,
//     editCategory,
//     deleteCategory,
//   } = useEventCategory();

//   const userId = "69579c6190a653b640e65639";

//   const [editing, setEditing] = useState(null);
//   const [openAdd, setOpenAdd] = useState(false);
//   const [alert, setAlert] = useState({ type: "", message: "" });

//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   useEffect(() => {
//     if (selectedOrganizer) loadCategories(selectedOrganizer);
//   }, [selectedOrganizer]);

//   useEffect(() => {
//   const handleOrganizerChange = (e) => {
//     setSelectedOrganizer(e.detail);
//   };

//   window.addEventListener("companyChanged", handleOrganizerChange);
//   return () =>
//     window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   return (
//     <>
//       <div className="mb-4 flex justify-end">
//         <button
//           className="rounded bg-blue-600 px-4 py-2 text-white"
//           onClick={() => setOpenAdd(true)}
//         >
//           + Add Event Category
//         </button>
//       </div>

//       {/* {alert.message && (
//         <Alert
//           type={alert.type}
//           message={alert.message}
//           autoClose
//           onClose={() => setAlert({ type: "", message: "" })}
//         />
//       )} */}

//       <EventCategoryTable
//         data={data}
//         loading={loading}
//         onEdit={setEditing}
//         onDelete={async (row) => {
//           try {
//             const res = await deleteCategory(row._id, {
//               is_deleted: true,
//               deleted_by: userId,
//             });

//             setAlert({
//               type: "success",
//               message: res.data?.message,
//             });

//             loadCategories(selectedOrganizer);
//           } catch (error) {
//             setAlert({
//               type: "error",
//               message:
//                 error.response?.data?.message ||
//                 "Unable to delete event category",
//             });
//           }
//         }}
//       />

//       {/* Add */}
//       <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
//         <EventCategoryModal
//           onClose={() => setOpenAdd(false)}
//           onSubmit={async (payload, setModalError) => {
//             try {
//               payload.append("created_by", userId);
//               await addCategory(payload);
//               setOpenAdd(false);
//               loadCategories(selectedOrganizer);
//             } catch (error) {
//               setModalError(
//                 error.response?.data?.message ||
//                 "Failed to create event category"
//               );
//             }
//           }}
//         />
//       </Modal>

//       {/* Edit */}
//       <Modal open={!!editing} onClose={() => setEditing(null)}>
//         <EventCategoryModal
//           initialData={editing}
//           onClose={() => setEditing(null)}
//           onSubmit={async (payload, setModalError) => {
//             try {
//               payload.append("updated_by", userId);

//               await editCategory(editing._id, payload);
//               setEditing(null);
//               loadCategories(selectedOrganizer);
//             } catch (error) {
//               setModalError(
//                 error.response?.data?.message ||
//                 "Failed to update event category"
//               );
//             }
//           }}
//         />
//       </Modal>

//     </>
//   );
// }

import { useEffect, useState, useCallback } from "react";
import { MdSearch, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import EventCategoryTable from "./EventCategoryTable";
import Modal from "components/common/Modal";
import Alert from "components/common/Alert";
import { useEventCategory } from "./hooks/useEventCategory";
import EventCategoryModal from "./EventCategoryModal";
import CustomButton from "components/CustomButton";
import { InputField } from "components/FormFields";

export default function EventCategoryContainer() {
  const {
    data,
    loading,
    paginationInfo,
    loadCategories,
    addCategory,
    editCategory,
    deleteCategory,
  } = useEventCategory();

  const userId = "69579c6190a653b640e65639";

  const [editing, setEditing] = useState(null);
  const [openAdd, setOpenAdd] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  // Debounce Search Input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  const fetchData = useCallback(() => {
    if (selectedOrganizer) {
      loadCategories(selectedOrganizer, {
        page,
        limit,
        search: debouncedSearch,
      });
    }
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };

    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const handleDeleteCategory = async (id) => {
    try {
      const res = await deleteCategory(id, {
        is_deleted: true,
        deleted_by: userId,
      });

      setAlert({
        type: "success",
        message: res.data?.message || "Event category deleted successfully",
      });

      fetchData();
    } catch (error) {
      setAlert({
        type: "error",
        message:
          error.response?.data?.message || "Unable to delete event category",
      });
    }
  };

  return (
    <TablePageLayout>
      <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <div className="flex flex-col">
          <InputField
            label="SEARCH"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search event category..."
            icon={<MdSearch className="text-lg text-gray-400" />}
          />
        </div>

        <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
          <CustomButton
            label="Add Event Category"
            icon={MdAddBox}
            iconPos="right"
            variant="solid"
            color="#02a9e0"
            onClick={() => setOpenAdd(true)}
          />
        </div>
      </div>

      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          autoClose
          onClose={() => setAlert({ type: "", message: "" })}
        />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading event categories...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <EventCategoryTable
            data={data}
            onEdit={setEditing}
            onDelete={handleDeleteCategory}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalCategories}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      {/* Add Modal */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)} title={"Create Event Category"}>
        <EventCategoryModal
          onClose={() => setOpenAdd(false)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("created_by", userId);
              await addCategory(payload);
              setOpenAdd(false);
              fetchData();
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                  "Failed to create event category"
              );
            }
          }}
        />
      </Modal>

      {/* Edit Modal */}
      <Modal open={!!editing} onClose={() => setEditing(null)} title={"Edit Event Category"}>
        <EventCategoryModal
          initialData={editing}
          onClose={() => setEditing(null)}
          onSubmit={async (payload, setModalError) => {
            try {
              payload.append("updated_by", userId);
              await editCategory(editing._id, payload);
              setEditing(null);
              fetchData();
            } catch (error) {
              setModalError(
                error.response?.data?.message ||
                  "Failed to update event category"
              );
            }
          }}
        />
      </Modal>
    </TablePageLayout>
  );
}